module.exports = __webpack_public_path__ + "media/images/countryrect/ge-3bffede3619d89bc9c2b81886c183cc0.svg";